<template>
<div class="chapter">
<div class="inner_page">
<p class="ct" id="d6e170r535"><b>Acknowledgments </b></p>
<p class="tx" id="d6e2485"><i>My earnest thanks to Barb Doyen of Doyen Literary Services, </i><i>Karen MacDowall Jones, Steve Spearman, Brian Epps, Leo Borges, </i><i>Tina Eliopulos, Todd Moffett, Lynn Forkos, Debi McCandrew, Bill Clayton, </i><i>Meg Galliano, Dr. James Williamson, Dr. Charles Mosely, Dr. Don Smith, </i><i>Dr. Robert Palinchak, and Dr. Ron Remington.</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Sher_9781440522697_epub_c6_r1.vue?647e53fc